import React from 'react';
import { CTAButton, TrustLine } from './CTAButton';
import { BOX_IMAGE, PURCHASE_ANCHOR } from '../data/content';
export function FinalCTA() {
  return <section className="bg-navy px-3 py-5 text-center sm:px-6" data-id="element-50" data-mp="3uei1xeuj5o1t">
      <div className="mx-auto max-w-2xl" data-id="element-51" data-mp="c7tzjwqv7ezu">
        <h2 className="font-heading text-[1.05rem] font-extrabold uppercase text-gold sm:text-[1.6rem]" data-id="element-52" data-mp="c4fuggqtgrop">
          One last question
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-[0.8rem] leading-[1.35] text-white/85 sm:text-[0.95rem]" data-id="element-53" data-mp="m3wxeqeoorgz">
          How many times have you started a cleaning job knowing exactly what
          needed to be done... but still had to search through messages, notes,
          checklists and client details again? You can keep managing clients,
          jobs, quotes and schedules through disconnected resources. Or you can
          open one organized professional system.
        </p>
        <p className="mt-1 font-heading text-[0.72rem] font-bold uppercase tracking-wide text-gold sm:text-sm" data-id="element-54" data-mp="zwv7zjzp6q54">
          Organize. Prepare. Clean. Control.
        </p>

        <a href={PURCHASE_ANCHOR} className="mt-1.5 block" data-id="element-55" data-mp="2c711dx38qnuc">
          <img src={BOX_IMAGE} alt="CLEANING READY™ complete system" className="mx-auto w-full max-w-[185px] drop-shadow-2xl" data-id="element-56" data-mp="2h4j3p4mr64td" />
        </a>

        <p className="mt-1 font-heading text-[1.15rem] font-extrabold uppercase leading-tight text-white sm:text-[1.6rem]" data-id="element-57" data-mp="2r2yq4uau4pwj">
          🧹 Cleaning Ready™
        </p>
        <p className="font-heading text-[0.66rem] font-bold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-58" data-mp="302c33wy63wm0">
          The Complete Ready-to-Use Operating System for Cleaning Professionals
        </p>
        <p className="mt-0.5 text-[0.66rem] text-white/70 sm:text-[0.8rem]" data-id="element-59" data-mp="39s5eawuee9pq">
          Clients • Services • Quotes • Scheduling • Communication • Operations
        </p>

        <p className="mt-2 font-heading text-[0.86rem] font-extrabold uppercase text-gold sm:text-base" data-id="element-60" data-mp="3epf3cbdvkjd1">
          🔥 Get the complete system today
        </p>
        <div className="mx-auto mt-1 max-w-md" data-id="element-61" data-mp="1jpej7b8in2rz">
          <CTAButton label="🧹 Get Cleaning Ready™" sub="Immediate Access • Digital Delivery" data-id="element-62" data-mp="1jlz80jhyqdvu" />
          <TrustLine className="mt-1.5 !text-white/75" data-id="element-63" data-mp="1sh6oz8mlhnq8" />
        </div>
      </div>
    </section>;
}